import { getPartialDateGivenMonthsAgo, isNumber } from 'neuro-utils';
import { TPlatformHandler } from '.';
import { partialDateToString } from '../utils/queryFormatters';

export const handleMgravisField: TPlatformHandler = (field, state) => {
  const { logicalOperators } = state;

  let query: string | undefined = undefined;
  switch (field) {
    case 'serologicalProfile': {
      query = '';
      if (state.serologicalProfile !== 'noCropping') {
        const parts: string[] = [];

        const logOp = logicalOperators.serologicalProfile;
        const S_AChR = state.serologicalProfile['S-AChR-Ab'];
        const MuSK = state.serologicalProfile['S-MuSKAb'];

        [S_AChR, MuSK].forEach((examination, index) => {
          if (examination) {
            let part = `examination@_€{data.code€{exists==TRUE&data==$${{ 0: '3427', 1: '6101' }[index]}}`;
            if (examination !== 'noCropping') {
              part += '&data.value€{exists==TRUE';
              const valueCheckParts = [];
              if (isNumber(examination.minValue)) {
                valueCheckParts.push(`data>=#${examination.minValue}`);
              }
              if (isNumber(examination.maxValue)) {
                valueCheckParts.push(`data<=#${examination.maxValue}`);
              }
              part += `&${valueCheckParts.join('&')}}`;
            }
            part += '}';
            parts.push(part);
          }
        });

        if (parts.length > 1) query += `(${parts.join(logOp === 'AND' ? '&' : '|')})`;
        else query += parts[0];
      }
      break;
    }

    case 'plasmaChangeDone': {
      query = '';
      if (state.plasmaChangeDone === 'yes' || state.plasmaChangeDone === 'no') {
        if (state.plasmaChangeDone === 'no') query += '!';
        // There are (no) procedure documents with procedure code 19647005 (plasma change)
        query += 'procedure@_€{data.code€{exists==TRUE&data.code==$19647005}}';
      }
      break;
    }

    case 'thymectomyDone': {
      query = '';
      if (state.thymectomyDone === 'yes' || state.thymectomyDone === 'no') {
        if (state.thymectomyDone === 'no') query += '!';
        // There are (no) procedure documents with procedure code 399750009 (thymectomy)
        query += 'procedure@_€{data.code€{exists==TRUE&data.code==$399750009}}';
      }
      break;
    }

    case 'hospitalWardDuringLast12Months': {
      query = '';
      if (state.hospitalWardDuringLast12Months !== 'noCropping') {
        if (state.hospitalWardDuringLast12Months === 'no') query += '!';
        query += `hospitalization@_€{data.date>=%${partialDateToString(
          getPartialDateGivenMonthsAgo(12),
        )}&data.department==$hospitalWard}`;
      }
      break;
    }

    case 'intensiveCareDuringLast12Months': {
      query = '';
      if (state.intensiveCareDuringLast12Months !== 'noCropping') {
        if (state.intensiveCareDuringLast12Months === 'no') query += '!';
        query += `hospitalization@_€{data.date>=%${partialDateToString(
          getPartialDateGivenMonthsAgo(12),
        )}&data.department==$intensiveCare}`;
      }
      break;
    }

    case 'latestMgcScore':
    case 'latestHcpReportedMgadlScore':
    case 'latestPatientReportedMgadlScore': {
      query = '';

      const stateValue = state[field];
      const func = {
        latestMgcScore: 'calculateLatestMGC',
        latestHcpReportedMgadlScore: 'calculateLatestHcpReportedMGADL',
        latestPatientReportedMgadlScore: 'calculateLatestPatientReportedMGADL',
      }[field];

      if (stateValue !== 'noCropping' && (isNumber(stateValue.minScore) || isNumber(stateValue.maxScore))) {
        const parts: string[] = [];

        if (isNumber(stateValue.minScore)) {
          parts.push(`data!=NULL&data>=#${stateValue.minScore}`);
        }

        if (isNumber(stateValue.maxScore)) {
          parts.push(`data<=#${stateValue.maxScore}`);
        }

        query = `§${func}€{${parts.join('&')}}`;
      }

      break;
    }

    default:
      return undefined;
  }

  return query;
};
